import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-sample-request-inventory-usage-report',
  templateUrl: './sample-request-inventory-usage-report.component.html',
  styleUrls: ['./sample-request-inventory-usage-report.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SampleRequestInventoryUsageReportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
